import module from 'viaticos/module.js'

export const schema = {
  autorizar: 'boolean',
  cerrar: 'boolean',
  configurar: 'boolean',
  maquilar: 'boolean',
  misviaticos: 'boolean',
  pagar: 'boolean',
  timbrar: 'boolean',
  todos: 'boolean',
}

export class ViaticosPendientesService {
  constructor ($http){
    this.$http = $http
  }

  get () {
    return this.$http.get(`/api/viaticos/viaticos/pendientes`, {
      schema
    })
  }
}

module.service('ViaticosPendientesService', ViaticosPendientesService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Pendientes.js